import { useEffect } from 'react';
import { enableSignupRefererForwarding } from '@gonfalon/dogfood-flags/dogfood-flags';
import { buildSignupCustomReferer, getForwardedReferer } from '@gonfalon/signup/agentUtmParams';

import { storeSignupLandingUrl } from '#utils/signupLandingUrlStorage';

/**
 * Captures the current landing URL (including any UTM/referer params) on mount
 * so it survives the OAuth redirect and is available as `customReferer` when
 * the account is created.
 *
 * Call this from every pre-auth entry point (signup and login pages). Capturing
 * on mount — rather than on OAuth-button click — is what lets OAuth signups be
 * attributed regardless of where the flow started, including Google One-Tap,
 * which auto-submits without going through a click handler.
 *
 * The referer is built the same way the OAuth click handler used to build it —
 * `getForwardedReferer` when the flag is on, `buildSignupCustomReferer` when
 * off — so attribution keeps working even where the flag is disabled (matching
 * the prior behavior; the flag only selects which builder is used).
 */
export function useCaptureSignupLandingUrl(): void {
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const referer = enableSignupRefererForwarding()
      ? getForwardedReferer(searchParams)
      : buildSignupCustomReferer(searchParams);
    storeSignupLandingUrl(referer);
  }, []);
}
